import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Banner } from '../models/banner.entity'

export type BannerNotificationCode =
  | GenericNotificationCode
  | 'BANNER_DELETED'
  | 'BANNER_NOT_FOUND'
  | 'BANNER_SAVED'

export type BannerModalCode = 'BANNER_DELETION'

/**
 * Parse banner code to a notification
 * @param code - the banner notification code
 * @returns the notification options
 */
export function parseBannerNotification(
  code?: BannerNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'BANNER_DELETED':
      return {
        message: 'Banner deleted successfully',
        color: 'success',
      }
    case 'BANNER_NOT_FOUND':
      return {
        message: 'Banner not found',
        color: 'success',
      }
    case 'BANNER_SAVED':
      return {
        message: 'Banner saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse banner code to an modal
 * @param code - the banner modal code
 * @param banner - the banner object
 * @returns the modal settings
 */
export function parseBannerModal(
  code: BannerModalCode,
  banner?: Banner,
): DialogOptions {
  switch (code) {
    case 'BANNER_DELETION': {
      const banName = banner?.name
      return {
        title: 'Delete banner',
        message:
          'You are about to delete the banner <strong>%s</strong>. Proceed with deletion?',
        messageParams: banName ? [banName] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
